// import React, { useState, useRef, useEffect } from 'react';
// import { LuBookOpenText } from "react-icons/lu";
// import { IoChatbox } from "react-icons/io5";
// import { FiRotateCcw, FiMenu, FiX } from "react-icons/fi";
// import { useAuth } from "../../context/auth";
// import { toast } from "react-toastify";

// // WhatsApp Button Component
// const WhatsAppButton = ({ darkMode }) => {
//   const { getLoginMail } = useAuth();
  
//   const handleClick = () => {
//     const url = "https://wa.me/918684953093?text=Hi";
//     window.open(url, "_blank");
//   };

//   return (
//     <button
//       onClick={handleClick}
//       className={`flex items-center gap-2 w-full px-3 py-2 text-left text-xs transition-all duration-200 group
//         ${darkMode 
//           ? 'text-gray-300 hover:bg-gray-700' 
//           : 'text-gray-700 hover:bg-gray-100'
//         }`}
//     >
//       <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
//         <IoChatbox size={11} className="text-white" />
//       </div>
//       <span>WhatsApp Support</span>
//     </button>
//   );
// };

// // Main Floating Menu Component
// const FloatingMenu = ({ activeTradeCopier = "admin", onResetLayout, darkMode = false }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [showGuide, setShowGuide] = useState(false);
//   const menuRef = useRef(null);
//   const buttonRef = useRef(null);
//   const guideRef = useRef(null);

//   // Close menu when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target) && 
//           !buttonRef.current?.contains(event.target)) {
//         setIsOpen(false);
//         setShowGuide(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Close guide when clicking outside (separate handler)
//   useEffect(() => {
//     const handleClickOutsideGuide = (event) => {
//       if (guideRef.current && !guideRef.current.contains(event.target) && 
//           !menuRef.current?.contains(event.target) &&
//           !buttonRef.current?.contains(event.target)) {
//         setShowGuide(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutsideGuide);
//     return () => document.removeEventListener("mousedown", handleClickOutsideGuide);
//   }, []);

//   const handleResetClick = () => {
//     if (onResetLayout) {
//       onResetLayout();
//       setIsOpen(false);
//       toast.success("Layout reset to default!");
//     }
//   };

//   const handleGuideClick = (e) => {
//     e.stopPropagation();
//     console.log("Guide clicked", showGuide); // Debug log
//     setShowGuide(!showGuide);
//   };

//   const handleMenuToggle = () => {
//     setIsOpen(!isOpen);
//     if (showGuide) setShowGuide(false);
//   };

//   const closeGuide = () => {
//     setShowGuide(false);
//   };

//   // Guide Content based on activeTab
//   const getGuideContent = () => {
//     switch (activeTradeCopier) {
//       case "admin":
//         return (
//           <div className="space-y-3">
//             <div className="flex items-start gap-2">
//               <span className="text-base">🛡️</span>
//               <span className="text-xs leading-relaxed">In this tab, you can <span className="font-semibold">send a request to copy trades from another user (Admin)</span>.</span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">⚙️</span>
//               <span className="text-xs leading-relaxed">Once the Admin <span className="font-semibold">accepts your request,</span> their trades will automatically be <span className="font-semibold">copied into your account.</span></span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">📊</span>
//               <span className="text-xs leading-relaxed"><span className="font-semibold">Subscription is required</span> to use this feature.</span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">🚨</span>
//               <span className="text-xs leading-relaxed">Only the <span className="font-semibold">Admin can set the multiplier</span> (to control trade quantity) and <span className="font-semibold">pause/unpause copying.</span></span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">🚨</span>
//               <span className="text-xs leading-relaxed">As a client, you can only <span className="font-semibold">view the multiplier and pause status set by the Admin.</span></span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">🚨</span>
//               <span className="text-xs leading-relaxed">Both you and the Admin can <span className="font-semibold">remove the request at any time.</span></span>
//             </div>
//           </div>
//         );

//       case "client":
//         return (
//           <div className="space-y-3">
//             <div className="flex items-start gap-2">
//               <span className="text-base">💼</span>
//               <span className="text-xs leading-relaxed">In this tab, you can <span className="font-semibold">view all clients connected to your account.</span></span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">📈</span>
//               <span className="text-xs leading-relaxed">You can <span className="font-semibold">accept or reject copy-trade requests</span> from clients.</span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">📊</span>
//               <span className="text-xs leading-relaxed">You can <span className="font-semibold">set a multiplier</span> for each client to control the trade quantity they copy.</span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">⚡</span>
//               <span className="text-xs leading-relaxed">You can <span className="font-semibold">pause or resume copying</span> for any client at any time.</span>
//             </div>
//             <div className="flex items-start gap-2">
//               <span className="text-base">⚡</span>
//               <span className="text-xs leading-relaxed">If a request is <span className="font-semibold">rejected,</span> it will remain visible for <span className="font-semibold">1 week</span> before being automatically removed.</span>
//             </div>
//           </div>
//         );
//       default:
//         return <p className="text-xs">Select a tab to see guide info.</p>;
//     }
//   };

//   return (
//     <div className="fixed bottom-4 right-4 z-50">
//       {/* Main Menu Button */}
//       <button
//         ref={buttonRef}
//         onClick={handleMenuToggle}
//         className={`p-2.5 rounded-full transition-all duration-300 shadow-lg
//           ${isOpen 
//             ? 'rotate-90 bg-gray-300 dark:bg-gray-600' 
//             : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600'
//           } ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}
//       >
//         {isOpen ? <FiX size={18} /> : <FiMenu size={18} />}
//       </button>

//       {/* Menu Items */}
//       {isOpen && (
//         <div 
//           ref={menuRef}
//           className={`absolute bottom-12 right-0 rounded-lg shadow-xl w-40 overflow-hidden border animate-slideUp mb-1
//             ${darkMode 
//               ? 'bg-gray-800 border-gray-700' 
//               : 'bg-white border-gray-200'
//             }`}
//         >
//           {/* Guide Button */}
//           <button
//             onClick={handleGuideClick}
//             className={`flex items-center gap-2 w-full px-3 py-2 text-left text-xs transition-all duration-200 group relative
//               ${darkMode 
//                 ? 'text-gray-300 hover:bg-gray-700' 
//                 : 'text-gray-700 hover:bg-gray-100'
//               }`}
//           >
//             <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
//               <LuBookOpenText size={11} className="text-white" />
//             </div>
//             <span>Guide</span>
//           </button>

//           {/* WhatsApp Button */}
//           <WhatsAppButton darkMode={darkMode} />

//           {/* Divider */}
//           <div className={`border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}></div>

//           {/* Reset Layout Button */}
//           <button
//             onClick={handleResetClick}
//             className={`flex items-center gap-2 w-full px-3 py-2 text-left text-xs transition-all duration-200 group
//               ${darkMode 
//                 ? 'text-red-400 hover:bg-red-900/20' 
//                 : 'text-red-600 hover:bg-red-50'
//               }`}
//           >
//             <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
//               <FiRotateCcw size={11} className="text-white" />
//             </div>
//             <span>Reset Layout</span>
//           </button>
//         </div>
//       )}

//       {/* Guide Popup - Separate from menu items */}
//       {showGuide && (
//         <div 
//           ref={guideRef}
//           className={`fixed bottom-16 right-16 rounded-xl shadow-2xl w-80 border animate-fadeInUp z-50
//             ${darkMode 
//               ? 'bg-gray-800 border-gray-700' 
//               : 'bg-white border-gray-200'
//             }`}
//           style={{ maxWidth: 'calc(100vw - 80px)' }}
//         >
//           {/* Guide Header */}
//           <div className={`flex items-center justify-between px-4 py-3 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
//             <h3 className={`text-sm font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
//               {activeTradeCopier === "admin" ? "📘 Admin Guide" : "📙 Client Guide"}
//             </h3>
//             <button
//               onClick={closeGuide}
//               className={`p-1 rounded-full transition-all ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
//             >
//               <FiX size={14} className={darkMode ? 'text-gray-400' : 'text-gray-500'} />
//             </button>
//           </div>

//           {/* Guide Content */}
//           <div className="p-4 max-h-[400px] overflow-y-auto">
//             {getGuideContent()}
//           </div>

//           {/* Guide Footer */}
//           <div className={`px-4 py-2 border-t text-center ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`}>
//             <span className="text-[10px]">Need help? Contact support</span>
//           </div>
//         </div>
//       )}

//       {/* Custom Animations */}
//       <style jsx>{`
//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translateY(8px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         @keyframes fadeInUp {
//           from {
//             opacity: 0;
//             transform: translateY(8px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
        
//         .animate-slideUp {
//           animation: slideUp 0.15s ease-out;
//         }
        
//         .animate-fadeInUp {
//           animation: fadeInUp 0.15s ease-out;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default FloatingMenu;







import React, { useState, useRef, useEffect } from 'react';
import { LuBookOpenText } from "react-icons/lu";
import { IoChatbox } from "react-icons/io5";
import { FiRotateCcw, FiMenu, FiX } from "react-icons/fi";
import { useAuth } from "../../context/auth";
import { toast } from "react-toastify";

// WhatsApp Button Component
const WhatsAppButton = ({ darkMode }) => {
  const handleClick = () => {
    const url = "https://wa.me/918684953093?text=Hi";
    window.open(url, "_blank");
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-2 w-full px-3 py-2 text-left text-xs transition-all duration-200 group
        ${darkMode 
          ? 'text-gray-300 hover:bg-gray-700' 
          : 'text-gray-700 hover:bg-gray-100'
        }`}
    >
      <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
        <IoChatbox size={11} className="text-white" />
      </div>
      <span>WhatsApp Support</span>
    </button>
  );
};

// Main Floating Menu Component
const FloatingMenu = ({ activeTradeCopier = "admin", onResetLayout, darkMode = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const guideRef = useRef(null);
  const { getLoginMail } = useAuth();
  
  // Get user ID for layout key
  const userEmail = getLoginMail?.() || "guest";
  const userId = userEmail.replace(/[^a-zA-Z0-9]/g, "_");

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && 
          !buttonRef.current?.contains(event.target)) {
        setIsOpen(false);
        setShowGuide(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close guide when clicking outside
  useEffect(() => {
    const handleClickOutsideGuide = (event) => {
      if (guideRef.current && !guideRef.current.contains(event.target) && 
          !menuRef.current?.contains(event.target) &&
          !buttonRef.current?.contains(event.target)) {
        setShowGuide(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideGuide);
    return () => document.removeEventListener("mousedown", handleClickOutsideGuide);
  }, []);

  const handleResetClick = () => {
    if (onResetLayout) {
      // Clear user's saved layout from localStorage
      const storageKey = `dockview-layout-${userId}`;
      localStorage.removeItem(storageKey);
      localStorage.removeItem(`${storageKey}-timestamp`);
      
      onResetLayout();
      setIsOpen(false);
      toast.success("Layout reset to default!");
    }
  };

  const handleGuideClick = (e) => {
    e.stopPropagation();
    setShowGuide(!showGuide);
  };

  const handleMenuToggle = () => {
    setIsOpen(!isOpen);
    if (showGuide) setShowGuide(false);
  };

  const closeGuide = () => {
    setShowGuide(false);
  };

  // Guide Content based on activeTab
  const getGuideContent = () => {
    switch (activeTradeCopier) {
      case "admin":
        return (
          <div className="space-y-3">
            <div className="flex items-start gap-2">
              <span className="text-base">🛡️</span>
              <span className="text-xs leading-relaxed">In this tab, you can <span className="font-semibold">send a request to copy trades from another user (Admin)</span>.</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">⚙️</span>
              <span className="text-xs leading-relaxed">Once the Admin <span className="font-semibold">accepts your request,</span> their trades will automatically be <span className="font-semibold">copied into your account.</span></span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">📊</span>
              <span className="text-xs leading-relaxed"><span className="font-semibold">Subscription is required</span> to use this feature.</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">🚨</span>
              <span className="text-xs leading-relaxed">Only the <span className="font-semibold">Admin can set the multiplier</span> (to control trade quantity) and <span className="font-semibold">pause/unpause copying.</span></span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">🚨</span>
              <span className="text-xs leading-relaxed">As a client, you can only <span className="font-semibold">view the multiplier and pause status set by the Admin.</span></span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">🚨</span>
              <span className="text-xs leading-relaxed">Both you and the Admin can <span className="font-semibold">remove the request at any time.</span></span>
            </div>
          </div>
        );

      case "client":
        return (
          <div className="space-y-3">
            <div className="flex items-start gap-2">
              <span className="text-base">💼</span>
              <span className="text-xs leading-relaxed">In this tab, you can <span className="font-semibold">view all clients connected to your account.</span></span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">📈</span>
              <span className="text-xs leading-relaxed">You can <span className="font-semibold">accept or reject copy-trade requests</span> from clients.</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">📊</span>
              <span className="text-xs leading-relaxed">You can <span className="font-semibold">set a multiplier</span> for each client to control the trade quantity they copy.</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">⚡</span>
              <span className="text-xs leading-relaxed">You can <span className="font-semibold">pause or resume copying</span> for any client at any time.</span>
            </div>
            <div className="flex items-start gap-2">
              <span className="text-base">⚡</span>
              <span className="text-xs leading-relaxed">If a request is <span className="font-semibold">rejected,</span> it will remain visible for <span className="font-semibold">1 week</span> before being automatically removed.</span>
            </div>
          </div>
        );
      default:
        return <p className="text-xs">Select a tab to see guide info.</p>;
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {/* Main Menu Button */}
      <button
        ref={buttonRef}
        onClick={handleMenuToggle}
        className={`p-2.5 rounded-full transition-all duration-300 shadow-lg
          ${isOpen 
            ? 'rotate-90 bg-gray-300 dark:bg-gray-600' 
            : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600'
          } ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}
      >
        {isOpen ? <FiX size={18} /> : <FiMenu size={18} />}
      </button>

      {/* Menu Items */}
      {isOpen && (
        <div 
          ref={menuRef}
          className={`absolute bottom-12 right-0 rounded-lg shadow-xl w-40 overflow-hidden border animate-slideUp mb-1
            ${darkMode 
              ? 'bg-gray-800 border-gray-700' 
              : 'bg-white border-gray-200'
            }`}
        >
          {/* Guide Button */}
          <button
            onClick={handleGuideClick}
            className={`flex items-center gap-2 w-full px-3 py-2 text-left text-xs transition-all duration-200 group relative
              ${darkMode 
                ? 'text-gray-300 hover:bg-gray-700' 
                : 'text-gray-700 hover:bg-gray-100'
              }`}
          >
            <div className="w-5 h-5 rounded-full bg-blue-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
              <LuBookOpenText size={11} className="text-white" />
            </div>
            <span>Guide</span>
          </button>

          {/* WhatsApp Button */}
          <WhatsAppButton darkMode={darkMode} />

          {/* Divider */}
          <div className={`border-t ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}></div>

          {/* Reset Layout Button */}
          <button
            onClick={handleResetClick}
            className={`flex items-center gap-2 w-full px-3 py-2 text-left text-xs transition-all duration-200 group
              ${darkMode 
                ? 'text-red-400 hover:bg-red-900/20' 
                : 'text-red-600 hover:bg-red-50'
              }`}
          >
            <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-200">
              <FiRotateCcw size={11} className="text-white" />
            </div>
            <span>Reset Layout</span>
          </button>
        </div>
      )}

      {/* Guide Popup */}
      {showGuide && (
        <div 
          ref={guideRef}
          className={`fixed bottom-16 right-16 rounded-xl shadow-2xl w-80 border animate-fadeInUp z-50
            ${darkMode 
              ? 'bg-gray-800 border-gray-700' 
              : 'bg-white border-gray-200'
            }`}
          style={{ maxWidth: 'calc(100vw - 80px)' }}
        >
          {/* Guide Header */}
          <div className={`flex items-center justify-between px-4 py-3 border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
            <h3 className={`text-sm font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>
              {activeTradeCopier === "admin" ? "📘 Admin Guide" : "📙 Client Guide"}
            </h3>
            <button
              onClick={closeGuide}
              className={`p-1 rounded-full transition-all ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`}
            >
              <FiX size={14} className={darkMode ? 'text-gray-400' : 'text-gray-500'} />
            </button>
          </div>

          {/* Guide Content */}
          <div className="p-4 max-h-[400px] overflow-y-auto">
            {getGuideContent()}
          </div>

          {/* Guide Footer */}
          <div className={`px-4 py-2 border-t text-center ${darkMode ? 'border-gray-700 text-gray-500' : 'border-gray-200 text-gray-400'}`}>
            <span className="text-[10px]">Need help? Contact support</span>
          </div>
        </div>
      )}

      {/* Custom Animations */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-slideUp {
          animation: slideUp 0.15s ease-out;
        }
        
        .animate-fadeInUp {
          animation: fadeInUp 0.15s ease-out;
        }
      `}</style>
    </div>
  );
};

export default FloatingMenu;